import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { JobServiceApi } from "../../services";
import * as jobConstants from "../../enums/jobs";

const initialState = {
  userId: 1,
  clientId: 1,
  totalFavoritesRecords: 0,
  page: 1,
  size: jobConstants.ROWS_PER_PAGE,
  basicFirst: 0,
  basicRows: jobConstants.ROWS_PER_PAGE,
  loading: false,
  error: '',
  favouritesJobList: [],
  targetFavouriteList: [],
  // sourceFavouriteList: [],
  userFavouritesJobList: [],
  lastUpdateFavourite: '',
}

export const fetchFavouritesJobs = createAsyncThunk('jobs/fetchFavouritesJobs', (req) => {
  return JobServiceApi.getFavouritesJobList(req).then(response => {
    // console.log("thunk res favourite", response?.data)
    return response?.data;
  });
});

export const addFavouriteJobList = createAsyncThunk('jobs/addFavouriteJobList', (req) => {
  return JobServiceApi.addFavouriteJobList(req).then(response => {
    // console.log("thunk res addFavouriteJobList", response?.data)
    return response?.data;
  });
});

export const fetchUserFavouritesJobs = createAsyncThunk('jobs/fetchUserFavouritesJobs', (req) => {
  return JobServiceApi.fetchUserFavouritesJobs(req).then(response => {
    // console.log("thunk res fetchUserFavouritesJobs", response?.data)
    return response?.data;
  });
});

const favouritesSlice = createSlice({
  name: 'favourites',
  initialState,
  reducers: {
    setTargetFavouriteList: (state, action) => {
      state.targetFavouriteList = action.payload;
    },
    // setSourceFavouriteList: (state, action) => {
    //   state.sourceFavouriteList = action.payload;
    // },
    setLastUpdateFavourite: (state, action) => {
      state.lastUpdateFavourite = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchFavouritesJobs.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchFavouritesJobs.fulfilled, (state, action) => {
      // console.log("redux res favourite", action.payload);
      state.loading = false;
      state.favouritesJobList = action?.payload?.data;
      state.totalFavoritesRecords = action?.payload?.data?.length;
      state.error = '';
    });

    builder.addCase(fetchFavouritesJobs.rejected, (state, action) => {
      state.loading = false;
      state.favouritesJobList = [];
      state.totalFavoritesRecords = 0;
      state.error = action.error.message;
    });


    builder.addCase(fetchUserFavouritesJobs.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchUserFavouritesJobs.fulfilled, (state, action) => {
      // console.log("redux res favourite", action.payload);
      state.loading = false;
      state.userFavouritesJobList = action?.payload?.data;
      state.error = '';
    });

    builder.addCase(fetchUserFavouritesJobs.rejected, (state, action) => {
      state.loading = false;
      state.userFavouritesJobList = [];
      state.error = action.error.message;
    });

  }
})

export default favouritesSlice.reducer;
export const {
  setTargetFavouriteList,
  // setSourceFavouriteList,
  setLastUpdateFavourite,
} = favouritesSlice.actions;
